import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'; 
import { store } from './store'; 
import { ApolloProvider } from '@apollo/client'; 
import { GoogleOAuthProvider } from '@react-oauth/google';
import client from './services/apollo/apolloClient'; 
import './index.css';
import App from './App';
import './i18n'; 

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <ApolloProvider client={client}>
        <Provider store={store}> 
          <App />
        </Provider>
      </ApolloProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
